export default  {
    propostaId: null,
    detalhamento: null,
    justificativa: null,
    valor: 0,
    mesDespesa: null
}
